module.exports = __webpack_public_path__ + "static/trevor-circle-906da33da06534621fc7ace7aa58b3f9.png";